import { chain, mapValues } from 'lodash';
import { DEFAULT_SHIPPING_FORM_STATE } from '../store/slices/shipping';
import { IShippingReducer } from '../store/slices/shipping/types';

const createFieldValue = (value: any, defaultField: any, defaultValue: string = '') => ({
  ...defaultField,
  value: value ?? defaultValue,
  error: ''
});

export const getShippingValuesFromCustomer = (endCustomer: any): Partial<IShippingReducer> =>
  chain(endCustomer)
    .pick([
      'email',
      'firstName',
      'lastName',
      'street',
      'streetNumber',
      'zipCode',
      '_country',
      'city',
      'gtcAndPrivacyCheckbox',
      'telephoneNumber',
      'billingAddress',
      'companyName'
    ])
    .mapValues((value, key) => {
      const defaultField =
        DEFAULT_SHIPPING_FORM_STATE[key as keyof typeof DEFAULT_SHIPPING_FORM_STATE];
      const isInvalidStructure = typeof defaultField !== 'object' || defaultField === null;

      if (isInvalidStructure) {
        throw new Error(`Invalid field structure for key: ${key}`);
      }

      // Special handling for nested billingAddress
      if (key === 'billingAddress' && typeof value === 'object' && value !== null) {
        return {
          ...DEFAULT_SHIPPING_FORM_STATE.billingAddress,
          value: mapValues(value, (nestedValue, nestedKey) => {
            const defaultNestedField =
              DEFAULT_SHIPPING_FORM_STATE.billingAddress.value[
                nestedKey as keyof typeof DEFAULT_SHIPPING_FORM_STATE.billingAddress.value
              ];

            const isInvalidNestedStructure =
              typeof defaultNestedField !== 'object' || defaultNestedField === null;

            if (isInvalidNestedStructure) {
              throw new Error(
                `Invalid nested field structure for key: billingAddress.${nestedKey}`
              );
            }

            return createFieldValue(nestedValue, defaultNestedField, '');
          })
        };
      }

      return createFieldValue(value, defaultField, '');
    })
    .value();
